<template>
  <div id="app" class="appBox">
    <Map />
  </div>
</template>

<script>
import Map from "./pages/Map.vue";
// import Map from "@/pages/modules/test.vue";

export default {
  name: "App",
  components: {
    Map,
  },
};
</script>
<style>
@import "@/assets/icon/iconfont.css";
@import "@/assets/icon/iconfont-weapp-icon.css";

html,
body {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
}

.appBox {
  width: 100%;
  height: 100%;
}
</style>

